module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-bottom-stone-path-background-remnants.a34fccf0.png";